module.exports = __webpack_public_path__ + "01_short_black.82d77ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_short_black.png
// module id = RkO9
// module chunks = 0